import { isDevEnv, isTestEnv } from '../utils/env';

import { GROUP_APP_ID, getAppId } from './app';

// 通用静态资源 CDN 域名（供业务代码使用）
// OSS 桶：https://oss.console.aliyun.com/bucket/oss-us-west-1/h5-reader-oss/object?spm=5176.8466032.bucket-list.50.473f1450V04hv6
export const STATIC_DOMAIN = `https://static.flicknovelcdn.com`;

// 图片资源 hosting 域名 https://image-tools.mytestdrama.com/index.html 工具上传
// OSS 桶：https://oss.console.aliyun.com/bucket/oss-us-west-1/c-common-img-hosting/object
export const IMG_HOSTING = 'https://static-img.flicknovelcdn.com/';
export const IMG_HOSTING_POPKON = 'https://static-img.popkondramacdn.com/';

// 主包 api 域名（绝对地址，与 release-1.1.0 一致）
const LEGACY_API_PROD_BASE = 'https://api-us.flicknovel.com';
const LEGACY_API_TEST_BASE = 'https://api-c.mytestdrama.com';
const LEGACY_API_DEV_BASE = 'https://api-c.mytestdrama.com';

// 分包 api 域名（同源路径，由 nginx 反代）
export const API_PROD_BASE = '/api-us';
export const API_TEST_BASE = '/api-c';
export const API_DEV_BASE = '/api-c';

// 反馈图片上传 OSS 配置
export const OSS_FEEDBACK_UPLOAD_PREFIX = 'feedback/';
export const OSS_FEEDBACK_REGION = 'us-west-1';
export const OSS_FEEDBACK_BUCKET = 'c-common-user-feedback';

/** 是否主包（appId === 984582） */
export function isMainPackage(): boolean {
    return getAppId() === GROUP_APP_ID;
}

/** 主包绝对 API 地址（仅按环境，不依赖运行时 appId） */
export function getLegacyApiBaseByEnv(): string {
    if (isDevEnv) {
        return LEGACY_API_DEV_BASE;
    }
    if (isTestEnv) {
        return LEGACY_API_TEST_BASE;
    }
    return LEGACY_API_PROD_BASE;
}

/** 分包同源 API 路径（仅按环境，不依赖运行时 appId） */
export function getSubpackageApiPathByEnv(): string {
    if (isDevEnv) {
        return API_DEV_BASE;
    }
    if (isTestEnv) {
        return API_TEST_BASE;
    }
    return API_PROD_BASE;
}

/** 获取 api 域名：主包（984582）走绝对地址，分包走当前页面域名同源反代 */
export const getApiBase = (): string => {
    if (isMainPackage()) {
        return getLegacyApiBaseByEnv();
    }
    return getSubpackageApiPathByEnv();
};
